import React from 'react';
import { render } from '@testing-library/react';
import { Eyebrow } from './Eyebrow';

describe('Eyebrow', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Eyebrow
				className="m-x-8 m-y-4"
				data-auto-sel="automation-selector"
			>
				Lorem ipsum dolor sit amet
			</Eyebrow>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
